import { render, staticRenderFns } from "./CalendarEventModalResource.vue?vue&type=template&id=4ca5c2fc&scoped=true"
import script from "./CalendarEventModalResource.vue?vue&type=script&lang=ts"
export * from "./CalendarEventModalResource.vue?vue&type=script&lang=ts"
import style0 from "./CalendarEventModalResource.vue?vue&type=style&index=0&id=4ca5c2fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca5c2fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ca5c2fc')) {
      api.createRecord('4ca5c2fc', component.options)
    } else {
      api.reload('4ca5c2fc', component.options)
    }
    module.hot.accept("./CalendarEventModalResource.vue?vue&type=template&id=4ca5c2fc&scoped=true", function () {
      api.rerender('4ca5c2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/activities/CalendarEventModalResource.vue"
export default component.exports